"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createCopyWithin;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _apply = _interopRequireDefault(require("../../_helpers/apply"));

var _reportmodified = _interopRequireDefault(require("../_reportmodified"));

var _seempleerror = _interopRequireDefault(require("../../_helpers/seempleerror"));

var _assign = _interopRequireDefault(require("../../_helpers/assign"));

function createCopyWithin(hasOptions) {
  return function copyWithin() {
    var originalCopyWithin = Array.prototype.copyWithin;
    /* istanbul ignore if  */

    if (typeof originalCopyWithin !== 'function') {
      throw (0, _seempleerror["default"])('array:nonexistent_method', {
        method: 'copyWithin'
      });
    } // +hasOptions is converted to 0 or 1 depending on its value (false/true)


    var argsLength = arguments.length - +hasOptions;
    var args = Array(argsLength);
    var givenEventOptions = hasOptions ? arguments[arguments.length - 1] : null;

    for (var i = 0; i < argsLength; i++) {
      args[i] = arguments[i];
    }

    (0, _apply["default"])(originalCopyWithin, this, args);
    var eventOptions = {
      method: 'copyWithin',
      self: this,
      added: [],
      removed: []
    }; // extend event options by custom event options if they are given

    if (hasOptions) {
      if (givenEventOptions && (0, _typeof2["default"])(givenEventOptions) === 'object') {
        (0, _assign["default"])(eventOptions, givenEventOptions);
      }
    }

    (0, _reportmodified["default"])(this, eventOptions);
    return this;
  };
}
//# sourceMappingURL=createcopywithin.js.map